<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">其他功能</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>内部转账</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create :tenant-list="tenantList" @refresh="getList"></create>
        <el-select v-model="tenantId" placeholder="租户筛选" clearable>
          <el-option
            v-for="item in tenantList"
            :key="item.id"
            :label="item.tenantName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapActions, mapState, mapGetters } from "vuex";
import List from "./components/list";
import Create from "./components/create";
import { tenantInfo } from "@/common/publicApi";
export default {
  name: "TransferInner",
  data() {
    return {
      tenantId: "",
      tenantList: [],
    };
  },
  components: {
    List,
    Create,
  },
  computed: {
    ...mapState("transferInner", ["pagination"]),
    ...mapGetters("transferInner", ["list"]),
  },
  methods: {
    ...mapActions("transferInner", ["reqList", "getCoinTypes"]),
    handleSearch() {
      this.getList({ page: 1, size: 25 });
    },
    getList(data = {}) {
      this.reqList({
        ...this.pagination,
        ...data,
        tenantId: this.tenantId || undefined,
      });
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.getCoinTypes();
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.el-select {
  width: 300px;
  margin-right: 10px;
}
</style>
